import { rateApi } from "../Api/Api";

const GET_RATE = 'RATE/GET-RATE';
const CALC_RATE = 'RATE/CALC-RATE';

let initialState = {
    base: 'USD',
    currency: ['USD', 'UAH', 'EUR', 'CNY'],
    currencyRate: {},
    result: {},
    calculated: 0
}

const rateReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_RATE: {
            return {
                ...state,
                currencyRate: action.currencyRate
            }
        }
        case CALC_RATE: {
            return {
                ...state,
                calculated: action.calculated
            }
        }
        default:
            return state;
    }
}

export const getRateSuccess = (currencyRate) => ({ type: GET_RATE, currencyRate });
export const calcRate = (calculated) => ({ type: CALC_RATE, calculated });

export const getRate = (base, currency) => (dispatch) => {
    rateApi.getRate(base)
        .then(data => {
            let result = {};
            currency.map(elem => result[elem] = data.rates[elem]);
            dispatch(getRateSuccess(result));
        })
}


export default rateReducer;